import { init as initPageContactsSection } from "../sections/page-contacts";
export function init() {
  const pageContactsSection = document.querySelector(
    ".shopify-section.page-contacts"
  );
  if (pageContactsSection instanceof HTMLElement) {
    initPageContactsSection();
  }
}
